/**
Copyright (c) 2022–2026 Podstack.ai
All rights reserved.
Proprietary and Confidential.
Unauthorized copying of this file, via any medium, is strictly prohibited.
This file is part of the Podstack Platform.
*/

// Shared header + tab bar for the GPU Pods section (Pods / Templates / History).
// History lives on /pods?view=history, so active state is passed explicitly
// rather than derived from NavLink path matching.

import React from 'react';
import { Link } from 'react-router-dom';
import { Tag } from '../console/ui';

export type PodsTab = 'pods' | 'templates' | 'history';

export const PODS_HISTORY_PATH = '/pods?view=history';

const PodsTabs: React.FC<{
  active: PodsTab;
  runningCount?: number;
  templateCount?: number;
  historyCount?: number;
}> = ({ active, runningCount, templateCount, historyCount }) => {
  const tabs: Array<{ id: PodsTab; label: string; to: string; badge?: React.ReactNode }> = [
    { id: 'pods', label: 'Pods', to: '/pods', badge: runningCount != null ? `${runningCount} running` : undefined },
    { id: 'templates', label: 'Templates', to: '/pods/templates', badge: templateCount },
    { id: 'history', label: 'History', to: PODS_HISTORY_PATH, badge: historyCount || undefined },
  ];
  return (
    <nav className="flex flex-wrap border-b border-ps-border" aria-label="GPU Pods sections">
      {tabs.map((t) => (
        <Link
          key={t.id}
          to={t.to}
          aria-current={active === t.id ? 'page' : undefined}
          className={`ps-tab ${active === t.id ? 'ps-tab-on' : ''}`}
        >
          {t.label}
          {t.badge != null && <Tag tone="off">{t.badge}</Tag>}
        </Link>
      ))}
    </nav>
  );
};

export default PodsTabs;
